import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "@/contexts";
import { AuthModal, TawkChat } from "@/components";
import {
  ArrowRightIcon,
  CheckIcon,
  VerifiedIcon,
  ModerationIcon,
  PrivacyIcon,
  VisibilityIcon,
  HeartIcon,
  UserIcon,
} from "@/svgs";
import "./index.css";

const IndexScreen: React.FC = () => {
  const { userData } = useUser();
  const navigate = useNavigate();

  const _isLoggedIn = Boolean(userData);

  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  return (
    <div className="v2-body">
      <TawkChat />

      <section className="v2-hero">
        <img
          src={process.env.REACT_APP_URL_HOME_BANNER}
          className="v2-hero-bg"
          alt="Mimo Cupido Casal"
          loading="eager"
        />
        <div className="v2-container">
          <div className="v2-hero-content">
            <span className="v2-sub-title">
              Relacionamentos de alto padrão, com conexões reais
            </span>
            <h1>
              Conheça pessoas que buscam mais do que conversas buscam{" "}
              <span className="v2-gold-text">
                compatibilidade, propósito e presença.
              </span>
            </h1>
            <p>
              Uma plataforma exclusiva para quem valoriza privacidade, respeito
              e relacionamentos com intenção.
            </p>

            {!_isLoggedIn ? (
              <button
                className="v2-btn-gold"
                type="button"
                onClick={() => setIsAuthModalOpen(true)}
              >
                <UserIcon />
                Solicitar Acesso Exclusivo
              </button>
            ) : null}

            <div className="v2-badge-info">
              <CheckIcon />
              <span>Cadastro rápido, seguro e gratuito</span>
            </div>
          </div>
        </div>
      </section>

      <section className="v2-privacy-section">
        <div className="v2-container">
          <div className="v2-privacy-wrapper">
            <div className="v2-privacy-left">
              <h2>
                Sua privacidade e segurança <br />
                <span className="v2-gold-text">são nossa prioridade</span>
              </h2>
              <p>
                Criamos um ambiente seguro e controlado para conexões reais
                entre pessoas que valorizam privacidade, respeito e
                relacionamentos de alto padrão.
              </p>
              <button
                type="button"
                className="v2-btn-outline"
                onClick={() => navigate("/seguranca")}
              >
                Saiba mais sobre segurança
                <ArrowRightIcon />
              </button>
            </div>

            <div className="v2-privacy-grid">
              <div className="v2-privacy-card">
                <div className="v2-privacy-card-icon">
                  <VerifiedIcon />
                </div>
                <h4>Perfis verificados e autenticados</h4>
                <p>
                  Garantimos maior confiabilidade com verificação de identidade
                  e perfis reais.
                </p>
              </div>

              <div className="v2-privacy-card">
                <div className="v2-privacy-card-icon">
                  <ModerationIcon />
                </div>
                <h4>Moderação ativa</h4>
                <p>
                  Monitoramento contínuo para manter um ambiente seguro e livre
                  de abusos.
                </p>
              </div>

              <div className="v2-privacy-card">
                <div className="v2-privacy-card-icon">
                  <PrivacyIcon />
                </div>
                <h4>Proteção avançada de dados</h4>
                <p>
                  Seus dados pessoais são criptografados e protegidos com
                  padrões modernos de segurança.
                </p>
              </div>

              <div className="v2-privacy-card">
                <div className="v2-privacy-card-icon">
                  <VisibilityIcon />
                </div>
                <h4>Controle total de visibilidade</h4>
                <p>
                  Você decide quem pode visualizar seu perfil e interagir com
                  você.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="v2-bottom-cta">
        <div className="v2-container">
          <div className="v2-bottom-cta-content">
            <div className="v2-cta-icon-heart">
              <HeartIcon stroke="#bfa073" />
            </div>

            <h2>Pronto para conhecer alguém compatível com você?</h2>
            <p>
              Junte-se a pessoas que buscam relacionamentos de alto padrão, com
              segurança, privacidade e intenção real.
            </p>

            {!_isLoggedIn ? (
              <button
                className="v2-btn-gold"
                type="button"
                onClick={() => setIsAuthModalOpen(true)}
              >
                <UserIcon />
                Solicitar Acesso Exclusivo
              </button>
            ) : null}
          </div>
        </div>
      </section>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </div>
  );
};

export default IndexScreen;
